import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
    useHistory,
    useLocation
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { primaryContractAdded, primaryContractSelector } from '../../../../store/reducers/primConReducer';
import { classAddedMobile, scrollMobileSelector } from '../../../../store/reducers/scrollMobileReducer';
import { secondContractSelector } from '../../../../store/reducers/secConReducer';
import { pathAdded } from '../../../../store/reducers/pathsReducer';
import { useForm } from "react-hook-form";
import Tooltip from '../../../registered/tooltip/Tooltip';
import ErrorMessage from "./error/ErrorMessage";
import Select from 'react-select';
import { promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';
import { yourInfoAddedPrimaryContractLinked, yourInformationSelector } from '../../../../store/reducers/yourInfoReducer';
import {emailValidationRegex, nameValidationRegex, emailValidationRegexAllowPersonal} from "../../../../constants";
import { registrationSettingsSelector } from '../../../../store/reducers/registrationSettingsReducer'; 

function PrimaryContract({ countryCodeArr }) {
    const dispatch = useDispatch();
    const primContractAdmin = useSelector(primaryContractSelector);
    const promoCode = useSelector(promoCodeSelector);
    const secondContract = useSelector(secondContractSelector);
    const registrationData = useSelector(registrationSettingsSelector);
    const yourInfo = useSelector(yourInformationSelector);
    const scroll = useSelector(scrollMobileSelector);
    const [scrollClass, setScrollClass] = useState(scroll);
    let history = useHistory();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const summary = params?.get("summary");
    const [fromSummary, setfromSummary] = useState(false);
    const [fromSummaryConfirmed, setFromSummaryConfirmed] = useState(false);
    const [countryCode, setCountryCode] = useState(primContractAdmin.countryCode);
    const [methodValue, setMethodValue] = useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);
    const [tooltipClass, setTooltipClass] = useState("more_info-closed small");
    const [selectClass, setSelectClass] = useState("react-select");
    const [openEmail, setOpenEmail] = useState(false);
    const [emailValidation, setEmailValidation] = useState(emailValidationRegex);
    const [tooltipClassEmail, setTooltipClassEmail] = useState("more_info-inline");
    const { register, handleSubmit, formState: { errors }} = useForm();
    const span = useRef();
    const span2 = useRef();
    const filteredArray = countryCodeArr.filter(code => { return code.value === primContractAdmin.countryCode})
    const splittData = registrationData.primary_contract_description.split("<br />");

    useEffect(() => {
        if(summary) {
            setfromSummary(summary);
        }
    }, [summary]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if(countryCode !== undefined) {
            setMethodValue(true);
        }
        if(promoCode.isHuri === true) {
            setEmailValidation(emailValidationRegexAllowPersonal);
        }
        setTimeout(function(){ setScrollClass("progression_container small") ; }, 10);
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
      }, [countryCode]); // eslint-disable-line

      useEffect(() => {
        document.addEventListener("mousedown", handleClickTooltip);
        return () => {
            document.removeEventListener("mousedown", handleClickTooltip);
        };
      }, []); // eslint-disable-line

    const handleClick = e => {
        if (span.current.contains(e.target)) {
            setOpenTooltip(true)
            setTooltipClass("more_info-active small")
            return;
        }
        setOpenTooltip(false)
        setTooltipClass("more_info-closed small")
    };
    const handleClickTooltip = e => {
        if (span2.current.contains(e.target)) {
            setOpenEmail(true)
            setTooltipClassEmail("more_info-inline active")
            return;
        }
        setOpenEmail(false)
        setTooltipClassEmail("more_info-inline closed")
    };

    function onSubmit(data, event) {
        data = {
            firstName: data.firstName,
            lastName: data.lastName,
            countryCode: countryCode,
            mobileNum: data.mobileNum,
            email: data.email,
        };
        const dataYourInfo = {
            firstName: data.firstName,
            lastName: data.lastName,
            countryCode: countryCode,
            mobileNum: data.mobileNum,
            primary: "yes"
        };
        
        if(methodValue) {
            if((summary === "true") && (fromSummaryConfirmed === true)) {
                dispatch(pathAdded(history.location.pathname));
                dispatch(primaryContractAdded(data));
                dispatch(classAddedMobile("progression_container small startBottom"));
                if(yourInfo.primary === "yes") {
                    dispatch(yourInfoAddedPrimaryContractLinked(dataYourInfo));
                } 
                history.push("/form/summary");
            } else {
                dispatch(classAddedMobile("progression_container small startBottom"));
                dispatch(pathAdded(history.location.pathname));
                dispatch(primaryContractAdded(data));
                if(yourInfo.primary === "yes") {
                    dispatch(yourInfoAddedPrimaryContractLinked(dataYourInfo));
                } 
                history.push(`/form/secondary`, {params: countryCodeArr});                                
            }
        }
    };

    function setMethod(e) {
        setMethodValue(true);
        setCountryCode(e.value);
    };

    function handleSelectClass() {
        if(methodValue === false ) {
            setSelectClass("select-error");
        }
    };

    function goToSummaryCheck() {
        if(methodValue === false ) {
            setFromSummaryConfirmed(false);
        } else {
            setFromSummaryConfirmed(true);
        }
    };

    function setClass() {
        dispatch(classAddedMobile("progression_container small startTop"));
    };

    return (
        <div className={scrollClass}>
            <h2 className="small">Primary contract administrator
                <span
                    className={tooltipClass}
                    ref={span}
                    onClick={handleClick}>                  
                        {openTooltip && (
                            <Tooltip title="" text={splittData[0] + splittData[1]} />
                        )}
                </span>
            </h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                    <label htmlFor="firstName">First name</label>
                    <input type="text" 
                        defaultValue={primContractAdmin.firstName} 
                        className={errors.firstName ? "errorInput" : ""} 
                        name="firstName" 
                        placeholder="Enter your first name" 
                        {...register("firstName", { 
                            required: "First name is required",
                            minLength: {
                                value: 2,
                                message: "Must be longer than 2 letters"
                            },
                            pattern: {
                                value: nameValidationRegex,
                                message: "Cannot contain numbers or special characters"
                            } 
                        })} 
                    />
                    {errors.firstName && <ErrorMessage>{errors.firstName.message}</ErrorMessage>}
                </div>

                <div className="form-group">
                    <label htmlFor="lastName">Last name</label>
                    <input type="text" defaultValue={primContractAdmin.lastName} className={errors.lastName ? "errorInput" : ""} name="lastName" placeholder="Enter your last name" 
                        {...register("lastName", { 
                        required: "Last name is required",
                        minLength: {
                            value: 2,
                            message: "Must be longer than 2 letters"
                        },
                        pattern: {
                            value: nameValidationRegex,
                            message: "Cannot contain numbers or special characters"
                        } 
                    })} />
                    {errors.lastName && <ErrorMessage>{errors.lastName.message}</ErrorMessage>}
                </div>

                <div className="form-group_container">
                    <div className="form-group form-countryCode">
                        <label htmlFor="countryCode">Country code</label>
                            <Select 
                                className={methodValue === false && selectClass}   
                                name="countryCode" 
                                defaultValue={primContractAdmin.countryCode !== undefined ? {label: filteredArray[0].label, value: primContractAdmin.countryCode } : {label: " - ", value: "" } }
                                options={countryCodeArr} 
                                searchable={false}
                                onChange={setMethod}
                                classNamePrefix="react-select"
                            />
                            {(selectClass === "select-error") && (methodValue === false) && <ErrorMessage>Please select a country code</ErrorMessage>}
                    </div>

                    <div className="form-group form-mobile">
                        <label htmlFor="mobileNum">Mobile number</label>
                        <input type="text" defaultValue={primContractAdmin.mobileNum} className={errors.mobileNum ? "errorInput" : ""} name="mobileNum" placeholder="Enter your number"
                            {...register("mobileNum", {
                                required: "Mobile number is required",
                                pattern: {
                                    value: /^([0-9]){4,12}$/,
                                    message: "invalid phone number. Example (12345678)"
                                }
                            })}
                        />
                        {errors.mobileNum && <ErrorMessage>{errors.mobileNum.message}</ErrorMessage>}
                    </div>
                </div>

                <div className="form-group">
                    <label className="email" htmlFor="email">E-mail
                        <span 
                            className={tooltipClassEmail} 
                            ref={span2}
                            onClick={handleClickTooltip}>                  
                                {openEmail && (
                                    <Tooltip title="" text={registrationData.primary_contract_email_information}/>
                                )}
                        </span>
                    </label>
                    <input type="text" defaultValue={primContractAdmin.email} className={errors.email ? "errorInput" : ""} name="email" placeholder="Enter your personal company email" {...register("email", {
                        required: "Email is required",
                        pattern: {
                            value: emailValidation,
                            message: "Invalid email address. Example: (john@yourcompany.no)"
                        },
                            validate: (value) => value !== secondContract.email   
                        })}
                    />
                    {errors.email && errors.email.type === "validate" && <ErrorMessage>This e-mail is already used for the Secondary contract administrator. It needs to be unique.</ErrorMessage>}
                    {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
                </div>

                <div className="button_container">
                    {!fromSummary ?
                        <Link to={`/form/info`} onClick={setClass} className="previous"><span>
                            <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                            </svg>
                        </span> Previous</Link>
                    :
                        <button className="summaryNavButton" type="submit" onClick={() => {handleSelectClass();goToSummaryCheck();}}>Back to summary</button>
                    }

                    <button onClick={() => { handleSelectClass(); window.plausible('Registration Primary Contract'); }} className="nextSubmit next" type="submit">
                        <span>Next</span>
                        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                        </svg>
                    </button>
                </div>
            </form>
        </div>
    );
}

export default PrimaryContract;
